import { render } from "./LimitedCompanyForm.vue?vue&type=template&id=793b7ba8&scoped=true"
import script from "./LimitedCompanyForm.vue?vue&type=script&lang=js"
export * from "./LimitedCompanyForm.vue?vue&type=script&lang=js"

import "./LimitedCompanyForm.vue?vue&type=style&index=0&id=793b7ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793b7ba8"]])

export default __exports__